import React from 'react';

import { Box, Typography } from '@mui/material';
import { ArrowIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import {
  badgeStyles,
  headerStyles,
  progressGroupStyles,
  titleGroupStyles,
  titleTextGroupStyles,
} from '../PathToSubmission.styles';

// The widget's identity strip. Shared by the loaded widget and its skeleton so the two cannot drift
// apart: only the right-hand slot differs between them (real progress + actions vs placeholders).
const PathToSubmissionHeader = ({ subtitle, children }) => (
  <Box sx={headerStyles}>
    <Box sx={titleGroupStyles}>
      <Box sx={badgeStyles}>
        <ArrowIcon size={16} />
      </Box>
      <Box sx={titleTextGroupStyles}>
        <Typography variant="bold16">Path to Submission</Typography>
        <Typography color="text.secondary" variant="regular12">
          {subtitle}
        </Typography>
      </Box>
    </Box>
    <Box sx={progressGroupStyles}>{children}</Box>
  </Box>
);

PathToSubmissionHeader.propTypes = {
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default PathToSubmissionHeader;
